const initialState = {
    portfolio: [
        {
            name: 'Unique Tech',
            img: 'uniqueTech.png',
            url: 'https://rockyatoyan.github.io/uniqueTech/',
            tags:[
                'HTML','SCSS','JS','GSAP','Gulp','Swiper'
            ]
        },
        {
            name: 'Avenue Fashion',
            github: 'https://github.com/RockyAtoyan/ave-shop/tree/master',
            img: 'ave.png',
            url: 'https://rockyatoyan.github.io/ave-shop/',
            tags:[
                'React','Redux','TypeScript','SCSS','Formik','Slick'
            ]
        },
        {
            name: 'Wooder',
            img: 'wooder.png',
            url: 'https://rockyatoyan.github.io/wooder/',
            tags:[
                'HTML5','SCSS','JavaScript','Swiper','Gulp'
            ]
        },
        {
            name: 'Forecast App',
            github: 'https://github.com/RockyAtoyan/forecast-app/tree/master',
            img: 'forecast.png',
            url: 'https://rockyatoyan.github.io/forecast-app/',
            tags:[
                'React','Redux','TypeScript','SCSS','Axios','Swiper'
            ]
        },
        {
            name: 'TodoList App',
            github: 'https://github.com/RockyAtoyan/todo-list/tree/master',
            img: 'todo.png',
            url: 'https://rockyatoyan.github.io/todo-list/',
            tags:[
                'React','Redux','TypeScript','SCSS'
            ]
        },
        {
            name: 'GoSurf',
            img: 'surf.png',
            url: 'https://rockyatoyan.github.io/Surf-landing-page/',
            tags:[
                'HTML5','SCSS','JavaScript','Swiper','Gulp'
            ]
        },
        {
            name: 'Aquamarine',
            github: 'https://github.com/RockyAtoyan/project-shop/tree/master',
            img: 'aqua.png',
            url: 'https://rockyatoyan.github.io/project-shop/',
            tags:[
                'React','Redux','TypeScript','SCSS','Slick'
            ]
        },
        {
            name: 'GoTrip',
            img: 'goTrip.png',
            url: 'https://rockyatoyan.github.io/GoTrip/',
            tags:[
                'HTML5','SCSS','JavaScript','Swiper','Gulp'
            ]
        },
        {
            name: 'Landing Page',
            img: 'rest.png',
            url: 'https://rockyatoyan.github.io/Restoran-landing-page/',
            tags:[
                'HTML5','SCSS','JavaScript','Swiper','Gulp'
            ]
        },
        {
            name: 'Agency',
            img: 'agency.png',
            url: 'https://rockyatoyan.github.io/agency/',
            tags:[
                'HTML5','SCSS','JavaScript','Slick','Gulp'
            ]
        },
    ],
    skills:[
        {name:'HTML5',image:'./assets/images/skills/html.svg'},
        {name:'CSS3',image:'./assets/images/skills/css.svg'},
        {name:'JavaScript',image:'./assets/images/skills/javascript.svg'},
        {name:'TypeScript',image:'./assets/images/skills/typescript.svg'},
        {name:'Jquery',image:'./assets/images/skills/jquery.svg'},
        {name:'SASS / SCSS',image:'./assets/images/skills/sass.svg'},
        {name:'React / React Hooks',image:'./assets/images/skills/react.svg'},
        {name:'Redux',image:'./assets/images/skills/redux.svg'},
        {name:'Git',image:'./assets/images/skills/git.svg'},
        {name:'MUI',image:'./assets/images/skills/mui.svg'},
        {name:'Photoshop',image:'./assets/images/skills/photoshop.svg'},
        {name:'Figma',image:'./assets/images/skills/figma.svg'},
    ],
    menuMode:false,
    activeLink:0,
}

export type SkillType = {
    name:string
    image:string
}

export type PortfolioItemType = {
    name:string
    img:string
    url:string
    tags:string[]
    github?:string
}

export const reducer = (state = initialState,action:ActionsType) => {
    if(action.type === "set-mode"){
        return {...state,menuMode: action.mode}
    }
    else if(action.type === "set-active-link") {
        return {...state,activeLink: action.n}
    }
    return {...state}
}

type ActionsType = setMenuMode | setActiveLinkType

type setMenuMode = {type:'set-mode',mode:boolean}
export const setMenuMode = (mode:boolean) => ({type:'set-mode',mode})

type setActiveLinkType = {type:'set-active-link',n:number}
export const setActiveLink = (n:number):setActiveLinkType => ({type:'set-active-link',n})